import { render, staticRenderFns } from "./eComplaintsTable.vue?vue&type=template&id=7fef730e"
import script from "./eComplaintsTable.vue?vue&type=script&lang=js"
export * from "./eComplaintsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports